var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"head-wrap"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }